import { BrowserRouter } from "react-router-dom";
import Container from "./containers/Container";

function App() {
  return (
    <BrowserRouter>
      <Container />
    </BrowserRouter>
  );
}

export default App;
